var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: {
            loading: _vm.loading,
            placeholder: "Tipo de proceso",
            "no-match-text": "No hay ningún tipo de proceso con tu búsqueda",
            size: "medium",
            "filter-method": _vm.updateFilter,
            multiple: "",
            filterable: "",
            clearable: "",
          },
          on: { focus: _vm.onFocus },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c(
            "el-option",
            {
              key: item.id,
              attrs: {
                label: _vm._f("processCodeFilter")(item.code),
                value: item.code,
              },
            },
            [
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "code" }, [
                  _vm._v(_vm._s(_vm._f("processCodeFilter")(item.code))),
                ]),
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(item.description)),
                ]),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }